var klaviyo = klaviyo || [];
klaviyo.init({
	account: 'QPRFQt',
	list: 'RfShQq',
	platform: 'shopify',
});
klaviyo.enable('backinstock', {
	trigger: {
		product_page_text: 'NOTIFY ME',
		product_page_class: 'btn button-cart1',
		product_page_text_align: 'center',
		product_page_margin: '0px',
		replace_anchor: true,
		replace_anchor_selector: '.cart',
	},
	modal: {
		headline: '{product_name}',
		body_content:
			'Register to receive a notification when this item comes back in stock.',
		email_field_label: 'Email',
		button_label: 'NOTIFY ME',
		subscription_success_label: "You're in! We'll let you know when it's back.",
		newsletter_subscribe_label: 'Add me to your email list.',
		subscribe_checked: true,
		footer_content: '',
		additional_styles: window.__klaviyoModalCss || '',
		drop_background_color: '#000',
		background_color: '#fff',
		text_color: '#222',
		button_text_color: '#fff',
		button_background_color: '#231f20',
		close_button_color: '#ccc',
		error_background_color: '#fcd6d7',
		error_text_color: '#C72E2F',
		success_background_color: '#d3efcd',
		success_text_color: '#1B9500',
	},
});
